import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

const API_ROOT = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");

export default function StudentUploadAtt() {
  const localUser = useMemo(() => {
    try { return JSON.parse(localStorage.getItem("user") || "null"); }
    catch { return null; }
  }, []);

  const moduleId = parseInt(localUser?.moduleId, 10);
  const navigate = useNavigate();

  const [file,    setFile]    = useState(null);
  const [message, setMessage] = useState("");
  const [error,   setError]   = useState("");
  const [loading, setLoading] = useState(false);

  const onFileChange = (e) => {
    setFile(e.target.files[0] || null);
    setMessage(""); setError("");
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!file) { alert("Please select a file."); return; }

    const ext = file.name.split(".").pop().toLowerCase();
    if (ext !== "txt") { setError("Invalid file format. Only .txt files are allowed."); return; }
    if (!file.name.startsWith("student")) { setError("Unknown file type. Expected student######.txt"); return; }

    setError(""); setMessage(""); setLoading(true);
    try {
      const content = await file.text();
      const res = await fetch(`${API_ROOT}/api/students/upload-attendance`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ moduleId, filename: file.name, content }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Upload failed");
      setMessage(data.message || "Data Uploaded");
    } catch (err) {
      setError(err.message || "Upload failed");
    } finally {
      setLoading(false);
    }
  };

  if (![4, 5].includes(moduleId)) {
    return (
      <div className="container mt-4">
        <div className="alert alert-danger">Unauthorized access Or Session Timed out.</div>
      </div>
    );
  }

  return (
    <div className="container-fluid mt-3">
      <h3 className="ctitle">Upload Student Attendance</h3>

      <div className="mb-3 d-flex flex-wrap gap-2">
        <button type="button" className="btn btn-primary btn-sm" onClick={() => navigate("/student-attendance")}>
          Monthly Attendance(Time With Leave)
        </button>
        <button type="button" className="btn btn-secondary btn-sm" onClick={() => navigate("/student-ind-att")}>
          Individual Attendance
        </button>
        <button type="button" className="btn btn-info btn-sm" onClick={() => navigate("/student-monthly-att-raw")}>
          Monthly Attendance(Raw)
        </button>
        <button type="button" className="btn btn-success btn-sm" onClick={() => navigate("/student-monthly-att-leave")}>
          Monthly Attendance(With Leave)
        </button>
      </div>

      {error   && <div className="alert alert-danger">{error}</div>}
      {message && <div className="alert alert-success">{message}</div>}

      <div className="col-lg-10">
        <form onSubmit={onSubmit}>
          <div className="col-sm-6 mb-2">
            <label className="form-label">File Name</label>
            <input
              type="file"
              className="form-control"
              accept=".txt"
              onChange={onFileChange}
              required
            />
          </div>
          <div className="col-sm-3 mt-2">
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? "Uploading..." : "Add Attendance"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
